/* Polsk katalog for locale-no.js (del 3 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'set.import.packages.statusUploaded': 'Przesłano',
  'set.import.packages.uploadedAt': 'Przesłano {date}',
  'set.import.packages.readAt': 'Ostatni odczyt {date}',
  'set.import.packages.importedAt': 'Zaimportowano do ksiąg {date}',
  'set.import.packages.notAvailable': 'Nieznany czas',
  'set.import.packages.unknownSize': 'Nieznany rozmiar',
  'set.import.packages.deleteConfirm': 'Usunąć {name}? Plik ZIP i tymczasowe dane analizy zostaną trwale usunięte. Z tego pakietu nie zaimportowano żadnych danych księgowych.',
  'set.import.packages.deletePreviousConfirm': 'Usunąć poprzedni pakiet importu {name}? Zaimportowane dane księgowe pozostaną. Dokumentów, które znajdują się tylko w tym starszym pliku ZIP, nie będzie można otworzyć po usunięciu.',
  'set.import.packages.deleteDialogTitle': 'Usunąć pakiet importu?',
  'set.import.packages.deleteDialogBody': 'Zamierzasz usunąć {name}. Plik ZIP i powiązane dane analizy zostaną trwale usunięte z backendu.',
  'set.import.packages.deletePreviousBody': 'Zamierzasz usunąć poprzedni pakiet importu {name}. Dane księgowe pozostaną, ale dokumentów, które znajdują się tylko w tym pliku ZIP, nie będzie można później otworzyć.',
  'set.import.packages.deleteIrreversible': 'Tej operacji nie można cofnąć.',
  'set.import.packages.replaceTitle': 'Zastąpić istniejący pakiet importu?',
  'set.import.packages.replaceBody': 'Masz już pakiet importu {name}. Gdy nowy pakiet zostanie przeanalizowany i zatwierdzony, stanie się aktywny, a wszystkie starsze pakiety ZIP zostaną usunięte z backendu.',
  'set.import.packages.replaceSafety': 'Istniejący pakiet jest zachowywany podczas przesyłania i analizy nowego. Jeśli analiza się nie powiedzie lub zostanie przerwana, obecny aktywny pakiet pozostanie nienaruszony.',
  'set.import.packages.replacePermanent': 'Po zatwierdzeniu usunięcia starego pakietu nie można cofnąć.',
  'set.import.packages.chooseReplacement': 'Wybierz nowy ZIP',
  'set.import.packages.deleteProtected': 'Pakiet jest używany w księgach i nie można go tu usunąć.',
  'set.import.packages.protectedHelp': 'To aktywne źródło zaimportowanych dokumentów dowodów księgowych, dlatego nie można go usunąć.',
  'set.import.packages.duplicateHelp': 'Zawartość pliku jest identyczna z aktywnym pakietem importu i można go usunąć.',
  'set.import.packages.deleting': 'Usuwanie...',
  'set.import.packages.delete': 'Usuń',
  'set.import.packages.deleted': 'Pakiet importu został usunięty.',
  'set.import.packages.deleteFailed': 'Nie udało się usunąć pakietu importu.',
  'set.import.packages.deleteMissing': 'Brak ścieżki zapisu pakietu importu.',
  'set.import.packages.download': 'Pobierz ZIP',
  'set.import.packages.downloading': 'Przygotowywanie...',
  'set.import.packages.downloadMissing': 'Brak ścieżki zapisu pakietu importu.',
  'set.import.packages.downloadStarted': 'Rozpoczęto pobieranie oryginalnego pliku ZIP.',
  'set.import.packages.downloadFailed': 'Nie udało się pobrać pakietu importu.',
  'set.import.years.title': 'Wybierz lata danych',
  'set.import.years.help': 'Importowane są tylko dane i liczby z wybranych lat. Rejestry i archiwum dokumentów są obsługiwane osobno.',
  'set.import.years.recommended': 'Zalecany okres',
  'set.import.years.previousOnly': 'Tylko poprzednie lata',
  'set.import.years.all': 'Wszystkie lata',
  'set.import.years.current': 'bieżący rok',
  'set.import.years.retentionWarning': 'Odznaczono {years}, które mogą nadal mieścić się w zwykłym okresie przechowywania. Upewnij się, że materiał jest przechowywany gdzie indziej.',
  'set.import.years.documentsPreserved': 'Oryginalny ZIP i archiwum dokumentów pozostają kompletne niezależnie od wyboru lat.',
  'set.import.years.importedTitle': 'Zaimportowane lata danych',
  'set.import.years.importedHelp': 'Możesz usunąć zaimportowane liczby za jeden rok bez usuwania pliku ZIP, archiwum dokumentów ani ręcznie utworzonych pozycji.',
  'set.import.years.removeYear': 'Usuń zaimportowane dane za {year}',
  'set.import.years.removeTitle': 'Usunąć zaimportowane dane za {year}?',
  'set.import.years.removeBody': 'Zaimportowany bilans otwarcia, historia raportów, otwarte pozycje dotyczące danego roku i zaimportowane statusy kontroli za {year} zostaną usunięte.',
  'set.import.years.removePreserves': 'Ręczne faktury, zakupy, dowody księgowe, rejestry, oryginalny ZIP i archiwum dokumentów zostaną zachowane.',
  'set.import.years.removeConfirm': 'Usuń dane',
  'set.import.years.removing': 'Usuwanie...',
  'set.import.years.removed': 'Usunięto zaimportowane punkty danych za {year}. Liczba: {count}.',
  'set.import.years.removeFailed': 'Nie udało się usunąć zaimportowanych danych rocznych.',
  'set.import.years.invalid': 'Wybierz prawidłowy rok importu.',
  'set.import.years.selectedLedgerRows': 'wierszy historii w wybranych latach',
  'set.showAll': 'Pokaż wszystkie',
  'set.count.accounts': 'kont bilansowych',
  'set.count.customers': 'klientów',
  'set.count.products': 'produktów',
  'set.count.openSalesInvoices': 'otwartych faktur sprzedaży',
  'set.count.openPurchaseInvoices': 'otwartych faktur dostawców',
  'set.count.suppliers': 'dostawców',
  'set.count.openingBalances': 'bilansów otwarcia',
  'set.import.after': 'Po imporcie',
  'set.noMatches': 'Brak wyników.',
  'set.preview': 'Podgląd',
  'set.previewHeading': 'Tak wygląda dokument',
  'set.preview.sender': 'Nadawca:',
  'set.preview.invoiceNo': 'Nr faktury:',
  'set.preview.invoiceDate': 'Data faktury:',
  'set.preview.dueDate': 'Termin płatności:',
  'set.preview.accountNo': 'Nr rachunku:',
  'set.preview.toPay': 'Do zapłaty:',
  'set.preview.docType': 'FAKTURA',
  'set.preview.noCustomer': 'Nie wybrano jeszcze klienta',
  'set.preview.net': 'Netto',
  'set.preview.vat': 'VAT',
  'set.preview.toPayShort': 'Do zapłaty',
  'set.menu.title': 'Menu boczne',
  'set.menu.help': 'Wybierz, które strony pojawiają się w menu po lewej. Strony podstawowe są zawsze widoczne.',
  'set.menu.showAll': 'Pokaż wszystkie strony',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Importuj',
  'set.data.accountingTitle': 'Import / eksport księgowości',
  'set.data.accountingSub': 'Importuj z innego systemu księgowego za pomocą jednego lub kilku plików ZIP, SAF-T, CSV lub Excel oraz eksportuj kopię zapasową i zestawienie księgowań.',
  'set.export': 'Eksportuj',
  'set.data.invoiceCsv': 'Faktury CSV',
  'set.data.invoiceTemplate': 'Szablon importu faktur',
  'set.data.bookkeepingCsv': 'Księgowania CSV',
  'set.data.reusePackage': 'Ponownie używa przesłanego pliku eksportu bez nowego przesyłania.',
  'set.data.resetAll': 'Wyczyść wszystkie dane',
  'set.data.deleteBusiness': 'Usuń firmę',
  'set.data.onlyOwnerSchedule': 'Tylko właściciel może zaplanować usunięcie.',
  'set.doc.tab': 'Dokumenty',
  'svc.mcpMissingRedirect': 'Usługa MCP nie zwróciła bezpiecznego przekierowania.',
  'route.dailySettlements': 'Raporty dobowe',
  'nav.dailySettlements': 'Raporty dobowe',
  'navhelp.dailySettlements': 'Raporty dobowe z systemów kasowych, systemów rezerwacji, platform wynajmu i sklepów internetowych. Sprawdź i zatwierdź przed zaksięgowaniem.',
  'dailySettlement.title': 'Raporty dobowe',
  'dailySettlement.sub': 'Rozliczenia z kasy, rezerwacji, wynajmu i sklepu internetowego. Nic nie zostanie zaksięgowane, dopóki tego nie zatwierdzisz.',
  'dailySettlement.refresh': 'Odśwież',
  'dailySettlement.loadError': 'Nie udało się pobrać raportów dobowych.',
  'dailySettlement.openSettings': 'Otwórz integracje',
  'dailySettlement.emptyTitle': 'Brak raportów dobowych',
  'dailySettlement.emptyText': 'Gdy źródło zostanie połączone i dostarczy rozliczenie, pojawi się ono tutaj do sprawdzenia i zatwierdzenia.',
  'dailySettlement.filter.open': 'Do obsłużenia',
  'dailySettlement.filter.ready': 'Gotowe',
  'dailySettlement.filter.review': 'Do sprawdzenia',
  'dailySettlement.filter.done': 'Zakończone',
  'dailySettlement.status.ready': 'Gotowe do zatwierdzenia',
  'dailySettlement.status.review': 'Do sprawdzenia',
  'dailySettlement.status.approved': 'Zaksięgowano',
  'dailySettlement.status.dismissed': 'Zamknięto bez księgowania',
  'dailySettlement.attentionTitle': 'Źródła wymagające uwagi',
  'dailySettlement.attentionStale': '{provider} nie dostarczył rozliczenia od {days} dni. Ostatnie było {date}.',
  'dailySettlement.attentionNever': '{provider} jest połączony, ale nigdy nie dostarczył rozliczenia.',
  'dailySettlement.homeWaiting': 'Gotowe do zatwierdzenia: {ready}, do sprawdzenia: {review}.',
  'dailySettlement.homeAction': 'Zobacz raporty dobowe',
  'set.doc.title': 'Dokumenty',
  'set.doc.sub': 'Przesyłaj i przechowuj własne dokumenty, np. umowy, ubezpieczenia lub statut.',
  'set.doc.drop': 'Przeciągnij pliki tutaj',
  'set.doc.dropHint': 'Lub dotknij, aby wybrać plik',
  'set.doc.empty': 'Nie przesłano jeszcze żadnych dokumentów.',
  'set.doc.added': 'Dodano',
  'set.doc.new': 'Nowy dokument',
  'set.doc.edit': 'Edytuj dokument',
  'set.doc.remove': 'Usuń dokument',
  'set.doc.open': 'Otwórz dokument',
  'set.doc.add': 'Dodaj dokument',
  'set.doc.name': 'Nazwa',
  'set.doc.namePh': 'Np. Ubezpieczenie OC 2026',
  'set.doc.nameRequired': 'Najpierw nadaj dokumentowi nazwę',
  'set.doc.type': 'Typ',
  'set.doc.attachTo': 'Domyślnie dołączany do',
  'set.doc.attachToHint': 'Dokument jest automatycznie dołączany do tych typów dokumentów wysyłanych do klienta — można go usunąć przy każdej wysyłce.',
  'set.doc.uploading': 'Przesyłanie...',
  'set.doc.uploaded': 'Przesłano dokument',
  'set.doc.saved': 'Zaktualizowano dokument',
  'set.doc.deleted': 'Usunięto dokument',
  'set.doc.deleteConfirm': 'Usunąć dokument „{name}”?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG lub WEBP. Maks. 10 MB.',
  'set.doc.unavailable': 'Strona dokumentów się nie załadowała. Odśwież stronę — jeśli nadal jest pusta, to błąd, któremu musimy się przyjrzeć.',
  'set.doc.target.offer': 'Oferty',
  'set.doc.target.orderConfirmation': 'Potwierdzenia zamówień',
  'set.doc.target.invoice': 'Faktury',
  'set.doc.target.creditNote': 'Faktury korygujące',
  'set.doc.target.subscription': 'Subskrypcje i listy',
  'set.doc.target.subscriptionHint': 'Dołączane do e-maili wysyłanych z subskrypcji lub listy klientów.',
  'set.doc.kind.agreement': 'Umowa',
  'set.doc.kind.insurance': 'Ubezpieczenie',
  'set.doc.kind.articles': 'Statut / akt założycielski',
  'set.doc.kind.authorization': 'Pełnomocnictwo',
  'set.doc.kind.certificate': 'Certyfikat',
  'set.doc.kind.standard_attachment': 'Załącznik standardowy',
  'set.doc.kind.other': 'Inne',
  'sale.att.standard': 'Standardowy',
  'sale.att.removeStandard': 'Nie dołączaj tym razem',
  'sale.att.remove': 'Usuń załącznik',
  'sub.standardDocs': 'Dołączone dokumenty standardowe: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Ustawienia księgowości',
  'set.acc.sub': 'Podstawowe ustawienia księgowości: pierwszy rok obrotowy, rejestracja VAT, metoda księgowa i podobne.',
  'set.acc.startYear': 'Rok początkowy',
  'set.acc.startYearHelp': 'Pierwszy rok obrotowy prowadzony w Plumme. Dokumenty i raporty sprzed tego roku należą do wcześniejszego systemu.',
  'set.acc.startInvoiceNo': 'Początkowy numer faktury',
  'set.acc.startInvoiceNoHelp': 'Numer, który otrzyma Twoja pierwsza faktura. Jeśli przechodzisz z innego systemu, ustaw go wyżej niż ostatni użyty numer, aby zachować ciągłą numerację (wymóg prawny).',
  'set.acc.vatStatus': 'Status VAT',
  'set.acc.vatStatusHelp': 'Czy firma jest zarejestrowana w Merverdiavgiftsregisteret. Obowiązek VAT powstaje, gdy obrót opodatkowany przekroczy 50 000 kr w ciągu 12 miesięcy. Rejestracja VAT oznacza, że naliczasz VAT od sprzedaży i odliczasz go od zakupów.',
  'set.acc.vatRegistered': 'Zarejestrowany w VAT',
  'set.acc.notVatRegistered': 'Niezarejestrowany w VAT',
  'set.acc.vatRegisteredFrom': 'Zarejestrowany w VAT od',
  'set.acc.vatRegisteredWhen': 'Czy firma była już zarejestrowana w VAT 1 stycznia {year}?',
  'set.acc.vatRegisteredWhenHelp': 'Księgowość w Plumme zaczyna się w {year} r. Od daty rejestracji VAT naliczany jest VAT od sprzedaży i zakupów — wcześniej żaden. Jeśli odpowiesz „tak”, data zostanie ustawiona na 1 stycznia {year}.',
  'set.acc.vatRegisteredPick': 'Wybierz odpowiedź',
  'set.acc.vatRegisteredAtStart': 'Tak, zarejestrowana przed {year}',
  'set.acc.vatRegisteredLater': 'Nie, zarejestrowana w trakcie {year} lub później',
  'set.acc.vatRegisteredUnknown': 'Nie wiem',
  'set.acc.vatRegisteredFromHelp': 'Data rejestracji firmy w VAT. Przed tą datą VAT nie jest naliczany; od tej daty VAT jest księgowany od sprzedaży i zakupów.',
  'set.acc.standardVat': 'Propozycja dla nowych pozycji sprzedaży',
  'set.acc.standardVatHelp': 'To tylko stawka, którą Plumme proponuje przy tworzeniu nowej pozycji sprzedaży. Firma może stosować kilka stawek VAT, a produkt lub pozycja faktury mogą nadpisać propozycję.',
  'set.acc.howFileVat': 'Jak rozliczasz VAT',
  'set.acc.vatPeriod': 'Okres VAT',
  'set.acc.vatPeriodHelp': 'Jak często składasz MVA-melding. Większość składa co dwa miesiące (6 okresów w roku). Małe firmy z obrotem poniżej 1 mln kr mogą wnioskować o rozliczenie roczne. Rozliczenie kwartalne i miesięczne stosuje się w szczególnych przypadkach.',
  'set.acc.midYearTitle': 'Start w trakcie roku (dane początkowe)',
  'set.acc.midYearHelp': 'Użyj tej opcji, jeśli zaczynasz korzystać z Plumme w trakcie roku obrotowego. Wprowadzasz wtedy dane początkowe — sprzedaż, koszty i VAT od początku roku — ze starego systemu, aby raporty roczne i MVA-melding były kontynuowane z prawidłowymi danymi.',
  'set.acc.midYear': 'Start w trakcie roku',
  'set.acc.enterOpening': 'Wprowadź dane początkowe',
  'set.acc.enterOpeningHelp': 'Otwiera formularz, w którym wpisujesz datę przejścia, dotychczasowy VAT oraz sprzedaż/koszty według kont z poprzedniego systemu.',
  'set.acc.ibHelp': 'Bilans otwarcia to aktywa, kapitał własny i zobowiązania firmy na początku roku — czyli bilans zamknięcia z poprzedniego roku. Wprowadź go, gdy zaczynasz nowy rok obrotowy w Plumme, aby bilans był poprawny od pierwszego dnia.',
  'set.acc.viewIb': 'Zobacz / edytuj bilans otwarcia',
  'set.acc.viewIbHelp': 'Otwiera zaksięgowany bilans otwarcia, w którym możesz zobaczyć pozycje, edytować je lub usunąć bilans.',
  'set.acc.addIb': 'Wprowadź bilans otwarcia',
  'set.acc.addIbHelp': 'Otwiera kreator, który pomaga ustawić bilans otwarcia — potwierdzasz datę początkową i wpisujesz pozycje bilansu (Winien/Ma) z poprzedniego roku.',
  'set.acc.extraAccountsHelp': 'Dodawaj dodatkowe konta tylko wtedy, gdy potrzebuje ich zestawienie obrotów i sald lub eksport.',
  'set.acc.searchPlaceholder': 'Szukaj w planie kont po numerze lub nazwie',
  'set.acc.searchNoHits': 'Żadne konto nie pasuje do „{query}”.',
  'set.acc.addAccount': 'Dodaj konto',
  'set.acc.addAccountHelp': 'Tworzy własne konto w planie kont. Używaj tego tylko wtedy, gdy brakuje potrzebnego konta — większość kont standardowych już istnieje.',
  'set.acc.accountNameHelp': 'Opisowa nazwa konta, wyświetlana w planie kont i raportach — np. „Oprogramowanie/subskrypcja”.',
  'set.acc.accountNoHelp': 'Czterocyfrowy numer konta. Pierwsza cyfra określa klasę konta: 1 aktywa, 2 kapitał własny/zobowiązania, 3 przychody, 4–7 koszty, 8 finanse i podatki.',
  'set.acc.accountClass': 'Klasa konta',
  'set.acc.accountClassHelp': 'Główna grupa, do której należy konto, wyznaczana automatycznie na podstawie pierwszej cyfry numeru konta. Decyduje, czy konto jest aktywem, zobowiązaniem, przychodem czy kosztem.',
  'set.acc.equivalent': 'Odpowiada kontu',
  'set.acc.equivalentHelp': 'Łączy własne konto z kontem standardowym. Dzięki temu Plumme wie, jak traktować konto przy zamknięciu roku i w zeznaniu podatkowym — aby własne konta trafiały prawidłowo do oficjalnych formularzy.',
  'set.acc.createAccount': 'Utwórz konto',
  'set.acc.ownAccounts': 'Własne konta',
  'set.acc.ownAccountsHelp': 'Konta dodane przez Ciebie poza standardowym planem kont. Tylko je można zmieniać lub usuwać.',
  'set.acc.noOwnAccounts': 'Brak jeszcze własnych kont.',
  'set.acc.removeAccount': 'Usuń konto',
  'set.acc.deactivated': 'dezaktywowane',
  'set.acc.standardAccounts': 'Konta standardowe',
  'set.acc.standardAccountsHelp': 'Wbudowany standardowy plan kont (NS 4102). Te konta są wspólne dla wszystkich i używane automatycznie podczas księgowania — rzadko trzeba dodawać własne.',
  'set.bank.title': 'Uzgadnianie bankowe',
  'set.bank.help': 'Uzgadnianie bankowe pomaga sprawdzić, czy zakupy, sprzedaż i płatności są zaksięgowane jeden raz i zgadzają się z rachunkiem bieżącym firmy.',
  'set.bank.activeFrom': 'Aktywne od',
  'set.bank.accounts': 'Rachunki bankowe',
  'set.bank.primaryHelp': 'Główny rachunek do faktur to domyślny rachunek, na który płacą klienci.',
  'set.bank.disabled': 'Wyłączone',
  'set.bank.invoiceAccount': 'Rachunek do faktur',
  'set.bank.activate': 'Aktywuj rachunek',
  'set.bank.setAsInvoice': 'Ustaw jako rachunek do faktur',
  'set.bank.accountNumber': 'Numer konta',
  'set.bank.ledgerAccount': 'Konto w księgowości',
  'set.bank.type': 'Typ',
  'set.bank.typeOperating': 'Bieżący',
  'set.bank.typeTax': 'Potrącenia podatkowe',
  'set.bank.typeSavings': 'Oszczędności',
  'set.bank.typePrivate': 'Prywatny',
  'set.bank.typeOther': 'Inny',
  'set.bank.openingBalance': 'Saldo początkowe do uzgadniania bankowego',
  'set.bank.openingBalanceDate': 'Data salda początkowego',
  'set.bank.reconcileIn': 'Uzgodnij w Banku',
  'set.bank.mustReconcile': 'Wymaga uzgodnienia',
  'set.bank.showInPayments': 'Pokaż w „Zapłacono z/do”',
  'set.bank.none': 'Nie zarejestrowano jeszcze żadnych rachunków bankowych.',
  'set.bank.cards': 'Karty powiązane z rachunkiem',
  'set.bank.cardsHelp': 'Paragony często pokazują tylko cztery ostatnie cyfry. Zarejestruj kartę, a Plumme rozpozna płatność bez czekania na wyciąg bankowy. Typ rachunku decyduje, czy zakup jest firmowy, czy jest wydatkiem prywatnym.',
  'set.bank.cardsNone': 'Rachunek nie ma karty',
  'set.bank.cardsNoneHelp': 'Zaznacz tutaj lub zarejestruj karty dla każdego rachunku płatniczego. Gdy wszystkie rachunki zostaną wyjaśnione, Plumme wie, jakie karty ma firma: paragon opłacony inną kartą zostanie wtedy zaproponowany jako wydatek prywatny, z adnotacją na dowodzie księgowym.',
  'set.bank.cardPromptTitle': 'Karty decydują: firma czy prywatnie',
  'set.bank.cardPromptBody': 'Plumme odczytuje numer karty z paragonu. Gdy wiemy, jakie karty ma firma, każdy zakup kartą jest rozstrzygany automatycznie: znana karta oznacza zakup firmowy — inna karta oznacza wydatek prywatny. Te rachunki nie mają jeszcze odpowiedzi:',
  'set.bank.cardPromptSkipHelp': 'Jeśli pominiesz, rachunek pozostanie niewyjaśniony, a źródło płatności dla paragonów kartowych trzeba będzie ustawiać ręcznie. Możesz to uzupełnić w dowolnym momencie.',
  'set.bank.cardPromptFill': 'Uzupełnij teraz',
  'set.bank.cardPromptSkip': 'Zapisz bez tego',
  'set.bank.accountFallback': 'Rachunek bankowy',
  'set.bank.receiptDefault': 'Domyślne źródło płatności dla dowodów księgowych',
  'set.bank.receiptDefaultSub': 'Używane tylko wtedy, gdy ani karta, ani wyciąg bankowy, ani historia nie wskazują, skąd zapłacono za zakup.',
  'set.bank.receiptDefaultLabel': 'Źródło płatności',
  'set.bank.receiptDefaultHint': 'Dowód księgowy będzie gotowy do zaksięgowania, ale oznaczony na pomarańczowo, że źródło zostało wybrane z góry, a nie odczytane z dokumentu.',
  'set.bank.receiptDefaultNone': 'Brak – zostaw dowód księgowy do kontroli',
  'set.bank.cardLast4': 'Cztery ostatnie cyfry',
  'set.bank.cardLabel': 'Nazwa karty',
  'set.bank.cardLabelPh': 'Np. Visa prywatna',
  'set.bank.cardAdd': 'Dodaj kartę',
  'set.bank.cardRemove': 'Usuń kartę',
  'set.bank.cardLast4Invalid': 'Wpisz cztery ostatnie cyfry karty.',
  'set.bank.cardDuplicate': 'Ta karta jest już zarejestrowana. Dwóch kart z tymi samymi czterema cyframi nie da się odróżnić na paragonie.',
  'set.access.title': 'Dostęp',
  'set.access.sub': 'Zaproś księgowego lub partnera z własnym loginem. Dostępem zarządza się za pomocą ról.',
  'set.access.activeBusiness': 'Aktywna firma',
  'set.access.active': 'Aktywna',
  'set.access.noBusinesses': 'Z użytkownikiem nie powiązano jeszcze żadnej firmy.',
  'set.access.newBusiness': 'Nowa firma',
  'set.access.inviteTitle': 'Zaproś partnera',
  'set.access.inviteSub': 'Zaproś księgowego lub innych partnerów i zobacz oczekujące zaproszenia.',
  'set.access.noAdmin': 'Nie masz roli administratora w wybranej firmie.',
  'set.access.noAdminSub': 'Tylko właściciel i administrator mogą zapraszać nowych użytkowników.',
  'set.access.email': 'E-mail',
  'set.access.role': 'Rola',
  'set.role.accountant': 'Księgowy',
  'set.role.admin': 'Administrator',
  'set.role.viewer': 'Tylko odczyt',
  'set.access.sendInvite': 'Wyślij zaproszenie',
  'set.access.invites': 'Zaproszenia',
  'set.access.invitesSub': 'Oczekujące zaproszenia dla aktywnej firmy.',
  'set.access.accept': 'Akceptuj',
  'set.access.pending': 'Oczekuje',
  'set.access.withdraw': 'Wycofaj',
  'set.access.noInvites': 'Brak oczekujących zaproszeń.',
  'set.access.deleteNote': 'Usuwa tylko wybraną firmę, a nie Twój login ani inne firmy.',
  'set.access.deleteBusiness': 'Usuń tę firmę',
  'set.access.onlyOwnerDelete': 'Tylko właściciel może usunąć firmę.',
  'set.saveChanges': 'Zapisz zmiany',
  'set.title': 'Ustawienia',
  'set.subtitle': 'Firma, profil użytkownika, dostęp, księgowość, bank, inwestycje i dane w jednym miejscu.',
  'set.tabsTitle': 'Karty ustawień',
  'set.tabsHelp': 'Każda karta to jeden obszar ustawień: Firma (dane firmy), Profil użytkownika (Ty), Dostęp (kto może co robić), Preferencje (powiadomienia i wyświetlanie), Księgowość (konfiguracja i plan kont), Bank, Inwestycje, Dane (import/eksport), Dokumenty, Integracje i Subskrypcja.',
  'set.company': 'Firma',
  'set.country': 'Kraj',
  'set.companyName': 'Nazwa firmy',
  'set.orgNumber': 'Numer organizacyjny',
  'set.phone': 'Telefon',
  'set.address': 'Adres',
  'set.zip': 'Kod pocztowy',
  'set.city': 'Miejscowość',
  'set.companyType': 'Forma prawna',
  'set.logo': 'Logo firmy',
  'set.logoAlt': 'logo',
  'set.logoHelp': 'Logo na faktury. PNG, JPG lub WebP, maks. 1 MB.',
  'set.uploadLogo': 'Prześlij logo',
  'set.previewInvoice': 'Podgląd faktury',
  'set.deleteLogo': 'Usuń logo',
  'set.inboxEmail': 'E-mail skrzynki odbiorczej dowodów księgowych',
  'set.inboxEmailHelp': 'Przekazuj tutaj faktury od dostawców i paragony, aby trafiały bezpośrednio do skrzynki odbiorczej.',
  'set.copyEmail': 'Kopiuj e-mail',
  'set.generateEmail': 'Wygeneruj nowy adres',
  'set.generateEmailHelp': 'Zmieniaj tylko, jeśli adres wyciekł lub otrzymuje spam. Istniejące integracje trzeba będzie zaktualizować.',
  'set.profile': 'Profil użytkownika',
  'set.profileSub': 'Dane powiązane z Twoim loginem.',
  'set.loggedInEmail': 'E-mail logowania',
  'set.mobile': 'Numer telefonu komórkowego',
  'set.saveProfile': 'Zapisz profil użytkownika',
  'set.subscription': 'Subskrypcja',
  'set.subscriptionSub': 'Rozliczeniami zarządza backend i Stripe, a nie lokalny plan testowy.',
  'set.openPortal': 'Otwórz portal klienta',
  'set.current': 'Obecny',
  'adv.eyebrow': 'Doradca finansowy',
  'adv.beta': 'Beta',
  'adv.updating': 'Aktualizowanie',
  'adv.lead': 'SuperPlumma analizuje Twoją księgowość i doradza Ci jak doświadczony dyrektor finansowy — za {year}.',
  'adv.tab.overview': 'Przegląd',
  'adv.tab.liquidity': 'Płynność i ryzyko',
  'adv.tab.sales': 'Sprzedaż i rentowność',
  'adv.tab.costs': 'Koszty',
  'adv.sales.title': 'Sprzedaż i rentowność',
  'adv.sales.sub': 'Zaksięgowane faktury sprzedaży za {year}',
  'adv.sales.help': 'Wszystkie dane są obliczane na podstawie zaksięgowanych faktur sprzedaży w wybranym roku i porównywane z tymi samymi danymi z poprzedniego roku. Szkice, faktury korygujące i oferty nie są uwzględniane.',
  'adv.sales.emptyTitle': 'Brak zaksięgowanych faktur sprzedaży',
  'adv.sales.emptyText': 'Gdy zaksięgujesz sprzedaż, obliczę rentowność klientów, czas płatności, poziom rabatów i to, które produkty rosną.',
  'adv.sales.periodYear': 'w {year}',
  'adv.sales.periodVsPrev': 'vs {year}',
  'adv.sales.invoiceCount': 'Faktury: {count}',
  'adv.sales.customerCount': 'Klienci: {count}',
  'adv.sales.recurringCount': 'Z fakturowaniem cyklicznym: {count}',
  'adv.sales.days': 'Dni: {days}',
  'adv.sales.noPayments': 'Jeszcze nic nie zapłacono',
  'adv.sales.kpi.revenue': 'Obrót',
  'adv.sales.kpi.growth': 'Wzrost obrotu',
  'adv.sales.kpi.growthHelp': 'Zmiana zaksięgowanej sprzedaży względem tego samego okresu poprzedniego roku. Wyświetlane jako „—”, jeśli brak danych z poprzedniego roku do porównania.',
  'adv.sales.kpi.avgInvoice': 'Średnia kwota faktury',
  'adv.sales.kpi.discount': 'Średni rabat',
  'adv.sales.kpi.discountHelp': 'Łączny rabat podzielony przez wartość faktur bez rabatu. Jeśli ta liczba rośnie, a wolumen nie, oddajesz marżę, nic nie zyskując.',
  'adv.sales.kpi.paymentDays': 'Czas płatności',
  'adv.sales.kpi.paymentDaysHelp': 'Średnia liczba dni od daty faktury do zarejestrowanej płatności. Liczą się tylko opłacone faktury — nieopłacone nie zawyżają średniej.',
  'adv.sales.kpi.repeat': 'Wskaźnik ponownych zakupów',
  'adv.sales.kpi.repeatHelp': 'Odsetek klientów z więcej niż jedną fakturą w roku. Wysoki wskaźnik ponownych zakupów daje bardziej przewidywalny obrót niż ta sama sprzedaż rozłożona na jednorazowych klientów.',
  'adv.sales.kpi.concentration': 'Koncentracja klientów',
  'adv.sales.kpi.concentrationHelp': 'Jaka część obrotu pochodzi od największego klienta. Powyżej 40 % oznacza, że jeden klient może sam zachwiać działalnością.',
  'adv.sales.kpi.recurring': 'Przychody cykliczne',
  'adv.sales.kpi.recurringHelp': 'Udział obrotu pochodzący z faktur cyklicznych lub subskrypcji.',
  'adv.sales.customers': 'Rentowność klientów',
  'adv.sales.customersSub': 'Obrót, czas płatności i poziom rabatów dla każdego klienta',
  'adv.sales.customersHelp': 'Klienci są posortowani według obrotu w wybranym roku. Trend porównuje z poprzednim rokiem — nowy klient bez danych z zeszłego roku otrzymuje osobne oznaczenie zamiast strzałki.',
  'adv.sales.col.customer': 'Klient',
  'adv.sales.col.revenue': 'Obrót',
  'adv.sales.col.grossProfit': 'Zysk brutto',
  'adv.sales.col.paymentSpeed': 'Czas płatności',
  'adv.sales.col.discount': 'Rabat',
  'adv.sales.col.jobs': 'Faktury',
  'adv.sales.col.trend': 'Trend',
  'adv.sales.partialProfit': 'Nie obliczono',
  'adv.sales.trendNew': 'Nowy klient w tym roku',
  'adv.sales.showAll': 'Pokaż wszystkich klientów ({count})',
  'adv.sales.showFewer': 'Pokaż mniej',
  'adv.sales.profitNote': 'Zysk brutto jest wyświetlany, gdy wszystkie pozycje faktur klienta mają zarejestrowany koszt własny. Starsze faktury i pozycje bez kosztu własnego są oznaczone jako „Nie obliczono”.',
  'adv.sales.products': 'Produkty i usługi',
  'adv.sales.productsSub': 'Obrót dla każdego produktu oraz co rośnie, a co spada',
  'adv.sales.productsHelp': 'Produkty pochodzą z pozycji faktur. Pozycje bez nazwy produktu są grupowane jako „Bez nazwy produktu”. Wzrost i spadek są mierzone względem tego samego produktu rok wcześniej.',
  'adv.sales.topRevenue': 'Największy obrót',
  'adv.sales.growing': 'Największy wzrost',
  'adv.sales.falling': 'Największy spadek',
  'adv.sales.noComparison': 'Brak danych z zeszłego roku do porównania',
  'adv.sales.verdictTag': 'Sprzedaż i rentowność w tej chwili',
  'adv.sales.verdict.concentration': '{name} odpowiada za {pct} % sprzedaży fakturowanej o wartości {revenue}. To obecnie największe ryzyko w Twojej sprzedaży — jeśli ten klient odejdzie, zniknie z nim większość obrotu.',
  'adv.sales.verdict.slowPayers': 'Sama sprzedaż wygląda dobrze, ale część klientów płaci powoli (liczba: {count}) — najwolniejszy potrzebuje {days} dni. Pieniądze są zarobione; po prostu czekasz na nie dłużej, niż trzeba.',
  'adv.sales.verdict.discounts': 'Udzielasz średnio {pct} % rabatu, łącznie {amount} w tym roku. To pieniądze z już zawartej sprzedaży — warto sprawdzić, czy rabat faktycznie zwiększa wolumen.',
  'adv.sales.verdict.growing': 'Sprzedaż wzrosła o {pct} % w porównaniu z zeszłym rokiem i wynosi teraz {revenue}. Nic w danych sprzedażowych nie wymaga teraz działania — najważniejsze to utrzymać tempo.',
  'adv.sales.verdict.shrinking': 'Sprzedaż spadła o {pct} % w porównaniu z zeszłym rokiem i wynosi {revenue}. To obecnie najwyraźniejszy sygnał w Twoich danych sprzedażowych.',
  'adv.sales.verdict.steady': 'Sprzedaż wynosi {revenue} (liczba faktur: {count}). Nie widzę sygnałów ostrzegawczych w danych sprzedażowych — poniższe działania to szanse, a nie problemy.',
  'adv.sales.moves.title': 'To zrobiłbym najpierw',
  'adv.sales.moves.sub': 'Priorytetowe działania, posortowane według efektu',
  'adv.sales.moves.help': 'Za każdym działaniem stoi liczba z Twoich własnych faktur. Rodzaj efektu określa, jaka to wielkość — dni, korony czy udział — i nigdy nie należy ich sumować.',
  'adv.sales.move.chaseSlowPayers.title': 'Zajmij się najwolniej płacącymi',
  'adv.sales.move.chaseSlowPayers.text': 'Klienci płacący wolniej niż pozostali: {count}. {name} płaci średnio po {days} dniach.',
});
